import React from 'react';
import { Field } from 'redux-form';
import styles from '../DetailForm.css';
import {
  alphabeticalAndSomeChar,
  inputField,
  Months,
  numberOnly,
  deformatCurrency,
  formatCurrency,
  renderSelectField,
  residenceOwnership,
} from '../utilsForm';

class ModalkuNewBusinessInfoForm extends React.Component {
  state = {
    business_current_debt: '',
    business_current_debt_installment: '',
  };

  render() {
    const { businessLocationsState, businessStartsState } = this.props;

    return (
      <div className={`col-md-12 col-lg-12`}>
        <div className="col-md-3">
          <label>Business Information</label>
        </div>
        <div className="col-md-9">
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
              Business Name<red>*</red>
            </label>
            <div className="col-sm-8">
              <Field
                component={inputField}
                name="business_name"
                maxLength="255"
                placeholder="Your business/company name"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                className={`form-control ${styles['account-name']}`}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="business_residence_ownership"
              className="col-sm-4 col-form-label"
            >
              Business Residence Ownership<red>*</red>
            </label>
            <div className="col-sm-8">
              <Field
                name="business_residence_ownership"
                className={`form-control ${styles['bank-select']}`}
                id="business_residence_ownership"
                component={renderSelectField}
              >
                <option value="" key="">
                  Select Your Residence Ownership
                </option>
                {residenceOwnership.map(option => (
                  <option value={option.name} key={option.name}>
                    {option.name}
                  </option>
                ))}
              </Field>
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
              Business Address<red>*</red>
            </label>
            <div className="col-sm-8">
              <Field
                component={inputField}
                name="business_address"
                maxLength="255"
                placeholder="Your Business Address"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                className={`form-control ${styles['account-name']}`}
                normalize={alphabeticalAndSomeChar()}
              />
            </div>
            <div className="col-sm-offset-4 col-sm-8">
              <Field
                component={inputField}
                name="business_city"
                maxLength="255"
                placeholder="City"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                className={`form-control ${styles['account-name']}`}
                normalize={alphabeticalAndSomeChar()}
              />
            </div>
            <div className="col-sm-offset-4 col-sm-8">
              <Field
                name="business_province"
                className={`form-control ${styles['bank-select']}`}
                id="business_location _id"
                component={renderSelectField}
              >
                <option key={0} value="">
                  Select Province...
                </option>
                {businessLocationsState.map(option => (
                  <option value={option.name} key={option.id}>
                    {option.name}
                  </option>
                ))}
              </Field>
            </div>
            <div className="col-sm-offset-4 col-sm-8">
              <Field
                component={inputField}
                name="business_zipcode"
                maxLength="5"
                placeholder="Zip"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                className={`form-control ${styles['account-name']}`}
                normalize={numberOnly()}
              />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
              When Does <br /> Your Business Start?<red>*</red>
            </label>
            <div className="col-sm-4 col-lg-2">
              <Field
                name="business_start_month"
                className={`form-control ${styles['bank-select']}`}
                component={renderSelectField}
              >
                <option value="" key="">
                  Month...
                </option>
                {Months.map(option => (
                  <option value={option.value} key={option.value}>
                    {option.name}
                  </option>
                ))}
              </Field>
            </div>
            <div className="col-sm-4 col-lg-2">
              <Field
                name="business_start_year"
                className={`form-control ${styles['bank-select']}`}
                component={renderSelectField}
              >
                <option value="" key="">
                  Year...
                </option>
                {businessStartsState.map(option => (
                  <option value={option.code} key={option.name}>
                    {option.name}
                  </option>
                ))}
              </Field>
            </div>
          </div>
        </div>
      </div>
    );
  }

  updateReduxFormField = (fieldName, e) => {
    let { value } = e.target;
    value = value.match(/[0-9]+|[.]+/g);
    value = value ? value.join() : '';

    const deformatedCurrency = deformatCurrency(value);
    const formattedCurrency = formatCurrency(value);
    this.setState({ [fieldName]: formattedCurrency });
    this.props.changeField(fieldName, deformatedCurrency);
  };
}

export default ModalkuNewBusinessInfoForm;
